import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import moment from 'moment';

import { Typography } from 'antd';

import { TeamOutlined, CalendarOutlined } from '@ant-design/icons';

import Overview from '../../components/overview';

import withErrorHandler from '../../../../hoc/withErrorHandler';
import axios from '../../../../shared/axios/axios';
import newAxios from '../../../../shared/axios/new-api-axios';

import EndorsementStatusChangeModal from './endorsement-status-change-modal';
import { pipelinePagesTypes } from '../../../../shared/constants/enums/pipelinePagesTypes';
import { siteUrls } from '../../../../shared/constants/siteUrls';
import { truckingCompanyTypes, userTypes } from '../../../../shared/constants/enums';
import { generateColumns, loadSingleBucket, loadData } from '../../helpers/pipelines-overview-helper';

import * as actions from '../../store/actions';
import * as sharedActions from '../../../../shared/store/actions';

import '../../styles.less';

let root;

const EndorsementsOverview = ({ rootContainer }) => {
  const [columns, setColumns] = useState({ val: null, callback: null });
  const [columnsFromBackend, setColumnsFromBackend] = useState(null);
  const [modalState, setModalState] = useState({ visible: false, itemToEdit: null, status: null, sourceCol: null, destCol: null });
  const [filters, setFilters] = useState(null);

  const userInfo = useSelector((state) => state.shared.userInfo);

  const dispatch = useDispatch();

  const { endorsementStatusesLoading, endorsementPipelinesControlConfig, endorsementPipelinesControlConfigLoading } = useSelector(
    (state) => state.endorsementsPipelines,
  );

  useEffect(() => {
    root = rootContainer;

    dispatch(actions.getEndorsementPipelinesControlConfig());

    dispatch(sharedActions.getAgentsLookup({ pageSize: 15, pageNumber: 1 }));

    dispatch(actions.getEndorsementStatuses()).then((res) => {
      if (res && res.length) {
        dispatch(sharedActions.getUserInfo());

        const colsFromBackend = generateColumns(res, 'value', true);

        setColumns({ val: colsFromBackend, callback: null });
        setColumnsFromBackend(colsFromBackend);
      }
    });
  }, []);

  useEffect(() => {
    if (!!columnsFromBackend && !!userInfo) {
      let tempFilters = {};

      if (userInfo.userType === userTypes.Agent) {
        tempFilters = { assignedTo: 1, agentIds: [userInfo.userId] };
      }

      loadAllData(true, tempFilters);
    }
  }, [columnsFromBackend, userInfo]);

  useEffect(() => {
    const { callback } = columns;
    callback && callback();
  }, [columns]);

  const loadAllData = async (resetPaging, filters) => {
    if (columnsFromBackend) {
      setFilters(filters);

      const updatedColumns = await loadData(columnsFromBackend, resetPaging, filters, 'getEndorsements', pipelinePagesTypes.EndorsementsOverview);

      setColumns({ val: updatedColumns, callback: null });
    }
  };

  const refresh = () => {
    loadAllData(true);
  };

  const handleLoadSingleBucketData = async (column, resetPage) => {
    const updatedColumns = await loadSingleBucket(
      columns.val,
      column,
      resetPage,
      filters,
      'getEndorsements',
      pipelinePagesTypes.EndorsementsOverview,
    );
    setColumns({ val: updatedColumns, callback: null });
  };

  const handleChangeStatus = (formData) => {
    const updatedColumns = { ...columns.val };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === modalState.sourceCol.name || updatedColumns[columnKey].name === modalState.destCol.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns({
      val: updatedColumns,
      callback: () => {
        handleCloseModal();

        dispatch(actions.changeEndorsementStatus(formData)).then(() => {
          handleLoadSingleBucketData(modalState.destCol, true);
          handleLoadSingleBucketData(modalState.sourceCol, true);
        });
      },
    });
  };

  const handleResetColumns = () => {
    const updatedColumns = { ...columns.val };
    let sourceCol;
    let destCol;

    Object.keys(updatedColumns).forEach((colKey) => {
      if (updatedColumns[colKey].name === modalState.sourceCol.name) {
        sourceCol = updatedColumns[colKey];
      }

      if (updatedColumns[colKey].name === modalState.destCol.name) {
        destCol = updatedColumns[colKey];
      }
    });

    sourceCol.items.push(modalState.itemToEdit);
    destCol.items = destCol.items.filter((item) => item.id !== modalState.itemToEdit.id);

    setColumns({
      val: updatedColumns,
      callback: () => handleCloseModal(),
    });
  };

  const handleShowModal = (sourceColumn, destColumn, source, destination, moved) => {
    const sourceItems = [...sourceColumn.items];
    const destItems = [...destColumn.items];
    sourceItems.splice(source.index, 1);
    destItems.splice(destination.index, 0, moved);

    const updatedColumns = { ...columns.val };

    updatedColumns[source.droppableId].items = sourceItems;
    updatedColumns[destination.droppableId].items = destItems;

    setColumns({
      val: updatedColumns,
      callback: () => setModalState({ visible: true, itemToEdit: moved, status: destColumn.status, sourceCol: sourceColumn, destCol: destColumn }),
    });
  };

  const handleCloseModal = () => {
    setModalState({ visible: false, itemToEdit: null, status: null, sourceCol: null, destCol: null });
  };

  const renderBucketItem = (item) => {
    return (
      <div className="pipeline-item">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <span title={'Insured'} className="text-ellipsis">
            {!!item.insuredName && !!item.insuredId ? (
              <a
                title={item.insuredName.trim()}
                href={siteUrls.getTruckingCompanyDetailsUrl(
                  endorsementPipelinesControlConfig?.isMomentumEnabled,
                  item.insuredId,
                  truckingCompanyTypes.Insured,
                )}
              >
                {item.insuredName.trim()}
              </a>
            ) : (
              'N/A'
            )}
          </span>
        </div>

        {!!item.carrierName && !!item.carrierId ? (
          <p style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text type="secondary">
              Carrier:{' '}
              <a
                href={siteUrls.getTruckingCompanyDetailsUrl(
                  endorsementPipelinesControlConfig?.isMomentumEnabled,
                  item.carrierId,
                  truckingCompanyTypes.Carrier,
                )}
              >
                {item.carrierName.trim()}
              </a>
            </Typography.Text>
          </p>
        ) : null}

        {!!item.followUpPerson ? (
          <p style={{ margin: '5px 0', fontSize: '12px' }} title={'Follow Up Person'}>
            <TeamOutlined style={{ marginRight: '5px' }} />
            <Typography.Text type="secondary">
              <a href={siteUrls.getAgentDetailsUrl(endorsementPipelinesControlConfig?.isMomentumEnabled, item.followUpPersonId)}>
                {item.followUpPerson.trim()}
              </a>
            </Typography.Text>
          </p>
        ) : null}

        {!!item.followUpDate ? (
          <div
            title={'Follow Up Date'}
            style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px 0', fontSize: '11px', alignItems: 'center' }}
          >
            <CalendarOutlined style={{ marginRight: '5px' }} />
            <Typography.Text type="secondary">{moment(item.followUpDate).format('MMM DD YYYY')}</Typography.Text>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <Overview
        columns={columns.val}
        renderBucketItem={renderBucketItem}
        type={pipelinePagesTypes.EndorsementsOverview}
        userInfo={userInfo}
        isLoading={endorsementStatusesLoading || endorsementPipelinesControlConfigLoading}
        refresh={refresh}
        showModal={handleShowModal}
        loadSingleBucketData={handleLoadSingleBucketData}
        rootContainer={rootContainer}
        configuratorEnabled={false}
        fetchData={loadAllData}
        isMomentumEnabled={endorsementPipelinesControlConfig?.isMomentumEnabled}
        canViewOnlyAssigned={endorsementPipelinesControlConfig?.canViewOnlyAssigned}
      />

      {modalState.visible ? (
        <EndorsementStatusChangeModal
          modalState={modalState}
          rootContainer={rootContainer}
          resetColumns={handleResetColumns}
          changeStatus={handleChangeStatus}
        />
      ) : null}
    </>
  );
};

export default connect(null, null)(hot(withErrorHandler(EndorsementsOverview, axios, root, newAxios)));
